import { useCallback, useRef } from 'react'

type KeyEvent = {
  key: string
}

export function useTabSelectHighlighted<T>(onSelect: (option: T) => void) {
  const highlightedOptionRef = useRef<T | undefined>(undefined)

  const handleItemHighlighted = useCallback((option?: T) => {
    highlightedOptionRef.current = option
  }, [])

  const handleTabKeyDown = useCallback(
    (event: KeyEvent) => {
      if (event.key !== 'Tab') return

      const highlightedOption = highlightedOptionRef.current
      if (!highlightedOption) return

      onSelect(highlightedOption)
    },
    [onSelect],
  )

  return {
    handleItemHighlighted,
    handleTabKeyDown,
  }
}
